import { temAcesso } from '@/shared/auth/temAcesso'

const Fornecedores = () => import('./Fornecedores.vue')
const FornecedorDetalhar = () => import('./FornecedorDetalhar.vue')
const FornecedorDadosCadastrais = () =>
    import('./../fornecedor/dadoscadastrais/DadosCadastraisDetalhar.vue')
const FornecedorPagamentos = () =>
    import('./../fornecedor/pagamentos/Pagamentos.vue')
const FornecedorDirfs = () => import('./../fornecedor/dirfs/Dirfs.vue')
const FornecedorCertidoes = () =>
    import('./../fornecedor/certidoes/Certidoes.vue')
const FornecedorContratos = () => import('../gescon/contratos/Contratos.vue')
const FornecedorContratoDetalhar = () =>
    import('../gescon/contratos/ContratoDetalhar.vue')
const FornecedorContratoRequisicoes = () =>
    import('../gescon/requisicoes/Requisicoes.vue')
const ContratoRequisicaoDetalhar = () =>
    import('../gescon/requisicoes/RequisicaoDetalhar.vue')

const Usuarios = () => import('../ctrlacesso/usuarios/Usuarios.vue')
const UsuarioForm = () => import('../ctrlacesso/usuarios/FornecedorUsuarioForm.vue')
const UsuarioDetalhar = () => import('../ctrlacesso/usuarios/UsuarioDetalhar.vue')


export default {
    path: 'fornecedores',
    name: 'Fornecedores',
    component: Fornecedores,
    beforeEnter: (to, from, next) => {
        if (temAcesso('GEST-FORNECEDORES-00')) {
            next()
        }
    },
    children: [
        {
            path: ':fornecedorId',
            name: 'Fornecedores_Detalhar',
            component: FornecedorDetalhar,
            beforeEnter: (to, from, next) => {
                if (temAcesso('GEST-FORNECEDORES-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'dadoscadastrais',
                    name: 'FornecedoresDadosCadastrais',
                    component: FornecedorDadosCadastrais,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GEST-FORNECEDORES-01')) {
                            next()
                        }
                    }
                },
                {
                    path: 'pagamentos',
                    name: 'FornecedoresPagamentos',
                    component: FornecedorPagamentos,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GEST-FORNECEDORES-01')) {
                            next()
                        }
                    }
                },
                {
                    path: 'dirfs',
                    name: 'FornecedoresDirfs',
                    component: FornecedorDirfs,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GEST-FORNECEDORES-01')) {
                            next()
                        }
                    }
                },
                {
                    path: 'usuarios',
                    name: 'UsuariosFornecedor',
                    component: Usuarios,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GEST-FORNECEDORES-02')) {
                            next()
                        }
                    },
                    children: [
                        {
                            path: 'inserir',
                            name: 'UsuariosFornecedor_Inserir',
                            component: UsuarioForm,
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('GEST-FORNECEDORES-02')) {
                                    next()
                                }
                            }
                        },
                        {
                            path: ':usuarioId',
                            name: 'UsuariosFornecedor_Detalhar',
                            component: UsuarioDetalhar,
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('GEST-FORNECEDORES-02')) {
                                    next()
                                }
                            }
                        },
                        {
                            path: ':usuarioId/atualizar',
                            name: 'UsuariosFornecedor_Atualizar',
                            component: UsuarioForm,
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('GEST-FORNECEDORES-02')) {
                                    next()
                                }
                            }
                        }
                    ]
                },
                {
                    path: 'contratos',
                    name: 'FornecedoresContratos',
                    component: FornecedorContratos,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GEST-FORNECEDORES-01')) {
                            next()
                        }
                    },
                    children: [
                        {
                            path: ':codContrato',
                            name: 'FornecedoresContratos_Detalhar',
                            component: FornecedorContratoDetalhar,
                            beforeEnter: (to, from, next) => {
                                if (temAcesso('GEST-FORNECEDORES-01')) {
                                    next()
                                }
                            },
                            children: [
                                {
                                    path: 'requisicoes',
                                    name: 'FornecedoresContratos_Requisicoes',
                                    component: FornecedorContratoRequisicoes,
                                    beforeEnter: (to, from, next) => {
                                        if (temAcesso('GEST-FORNECEDORES-01')) {
                                            next()
                                        }
                                    },
                                    children: [
                                        {
                                            path: ':idRequisicao',
                                            name:
                                                'FornecedoresContratos_RequisicaoDetalhar',
                                            component: ContratoRequisicaoDetalhar,
                                            beforeEnter: (to, from, next) => {
                                                if (
                                                    temAcesso(
                                                        'GEST-FORNECEDORES-01'
                                                    )
                                                ) {
                                                    next()
                                                }
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'certidoes',
                    name: 'FornecedoresCertidoes',
                    component: FornecedorCertidoes,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('GEST-FORNECEDORES-01')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
